import { useEffect, useState } from 'react';
import { Card, Carousel, Row, Col, Container } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom'; // ✅ 1. Importar useNavigate
import './MarcasDestacadas.css';

// ✅ Variable de entorno
const API_URL = import.meta.env.VITE_API_URL;

function MarcasDestacadas() {
  const [marcas, setMarcas] = useState([]);
  const navigate = useNavigate(); // ✅ 2. Inicializar el hook

  useEffect(() => {
    fetch(`${API_URL}/destacados/marcas`)
      .then(res => res.json())
      .then(data => setMarcas(data))
      .catch(err => console.error('❌ Error cargando marcas:', err));
  }, []);

  // Agrupar de a 4
  const grouped = [];
  for (let i = 0; i < marcas.length; i += 4) {
    grouped.push(marcas.slice(i, i + 4));
  }

  // ✅ 3. Función para ir a la página de la marca
  const goToBrandPage = (nombre) => {
    const brandId = nombre.toLowerCase().replace(/\s+/g, '-'); // Ej: "Audio Technica" -> "audio-technica"
    navigate(`/marcas/${brandId}`);
  };

  return (
    <section className="py-5 featured-brands">
      <Container>
        <div className="featured-section-head text-center mb-4">
          <span className="featured-section-chip">Curado por Vintage Pro</span>
          <h2 className="mb-2">Marcas Destacadas</h2>
          <p className="featured-section-subtitle mb-0">
            Selección de fabricantes confiables para proyectos de audio profesional.
          </p>
        </div>
        <Carousel indicators={false} controls={grouped.length > 1}>
          {grouped.map((grupo, idx) => (
            <Carousel.Item key={idx}>
              <Row className="g-4 justify-content-center">
                {grupo.map((marca) => (
                  <Col md={3} sm={6} xs={12} key={marca.id}>
                    <Card
                      className="h-100 text-center shadow-sm brand-card"
                      style={{ cursor: 'pointer' }}
                      onClick={() => goToBrandPage(marca.nombre)} // ✅ 4. Click para navegar
                    >
                      <div className="brand-logo-frame">
                        <Card.Img
                          variant="top"
                          src={marca.img}
                          className="brand-logo-img"
                          alt={marca.nombre}
                        />
                      </div>
                      <Card.Body className="brand-card-body">
                        <Card.Title className="brand-title">{marca.nombre}</Card.Title>
                        <p className="brand-card-cta mb-0">Explorar productos</p>
                      </Card.Body>
                    </Card>
                  </Col>
                ))}
              </Row>
            </Carousel.Item>
          ))}
        </Carousel>
      </Container>
    </section>
  );
}

export default MarcasDestacadas;
